import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/about/about-client.tsx");
